module.exports = __webpack_public_path__ + "img/logo-auth.5b1dfdca.svg";